import React from "react";

import { Link } from "react-router-dom";
import Helper from "../../Helper/helper";
import { injectStripe, CardElement } from "react-stripe-elements";
import api from "../../../Environment";
import { withToastManager } from "react-toast-notifications";
import ToastDemo from "../../Helper/toaster";
import AddCardLoader from "../../Loader/AddCardLoader"

import { translate, t } from "react-multi-lang";
import {
  loadInvoiceCheckoutSession,
  saveInvoiceCheckoutSession,
} from "./checkoutPaymentHelpers";
import "./CheckoutPayment.css";

class AddCardComponent extends Helper {
  state = {
    data: {
      card_number: "",
      month: "",
      year: "",
      cvv: "",
    },
    loadingContent: null,
    buttonDisable: false,
  };

  returnAfterSave = () => {
    var session = loadInvoiceCheckoutSession();
    if (session && session.subscription) {
      saveInvoiceCheckoutSession(
        Object.assign({}, session, { paymentMode: "card" })
      );
      if (this.props.history) {
        this.props.history.push({
          pathname: session.path || "/invoice",
          state: { subscription: session.subscription },
        });
        return;
      }
    }
    if (this.props.history) {
      this.props.history.push("/card-details");
    }
  };

  addCard = (ev) => {
    ev.preventDefault();
    this.setState({
      loadingContent: t("loading_text"),
      buttonDisable: true,
    });
    if (this.props.stripe) {
      this.props.stripe
        .createToken({
          type: "card",
          name: localStorage.getItem("username"),
        })
        .then((payload) => {
          if (payload.error) {
            ToastDemo(this.props.toastManager, payload.error.message, "error");
            this.setState({
              loadingContent: null,
              buttonDisable: false,
            });
          } else {
            const inputData = {
              card_token: payload.token.id,
            };
            api
              .postMethod("payment_card_add", inputData)
              .then((response) => {
                if (response.data.success) {
                  ToastDemo(
                    this.props.toastManager,
                    response.data.message,
                    "success"
                  );
                  this.setState({
                    loadingContent: null,
                    buttonDisable: false,
                  });
                  this.returnAfterSave();
                } else {
                  ToastDemo(
                    this.props.toastManager,
                    response.data.error_messages,
                    "error"
                  );
                  this.setState({
                    loadingContent: null,
                    buttonDisable: false,
                  });
                }
              })
              .catch((error) => {
                ToastDemo(this.props.toastManager, error, "error");
                this.setState({
                  loadingContent: null,
                  buttonDisable: false,
                });
              });
          }
        });
    } else {
      ToastDemo(
        this.props.toastManager,
        "Stripe.js hasn't loaded yet.",
        "error"
      );
      this.setState({
        loadingContent: null,
        buttonDisable: false,
      });
    }
  };

  render() {
    const { t } = this.props;
    var billingImg = {
      backgroundImage: "url(../assets/img/card-image.png)",
    };
    return (
      <div>
        <div className="main padding-top-md">
          <div className="top-bottom-spacing">
            <div className="row">
              <div className="col-sm-10 col-md-11 col-lg-9 col-xl-8 auto-margin">
                <div className="row m-0">
                  <div className="col-sm-12 col-md-5 col-lg-5 col-xl-5 p-0">
                    <div className="billing-img relative" style={billingImg}>
                      <div className="view-cards d-none d-md-block do-lg-block d-xl-block">
                        <Link to="/card-details" className="capitalize">
                          <i className="fas fa-chevron-right mr-1" />
                          {t("card_details")}
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-7 col-lg-7 col-xl-7 p-0">
                    <div className="billing-content-sec checkout-add-card-panel">
                      <h4 className="billing-head">
                        <i className="far fa-credit-card mr-2" />
                        {t("add_card")}
                      </h4>
                      <p className="grey-line" />
                      <form className="auth-form checkout-add-card" onSubmit={this.addCard}>
                        <label className="d-block capitalize" htmlFor="checkout-card-element">
                          {t("card_payment")}
                        </label>
                        <div className="checkout-add-card__element" id="checkout-card-element">
                          <CardElement
                            style={{
                              base: {
                                fontSize: "16px",
                                lineHeight: "24px",
                                color: "#333",
                                "::placeholder": { color: "#6c757d" },
                              },
                            }}
                          />
                        </div>
                        <div className="checkout-add-card__actions">
                          <button
                            type="submit"
                            className="btn btn-danger checkout-add-card__save"
                            disabled={this.state.buttonDisable}
                          >
                            {this.state.loadingContent != null
                              ? this.state.loadingContent
                              : this.props.t("save")}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default injectStripe(withToastManager(translate(AddCardComponent)));
